<template>
  <div>
    <h3>General description</h3>
    <p>
      The metrics computed in the simulation may be presented in different
      histograms, that gather the data generated in several intervals (bins).
      The available histograms are described below:
    </p>

    <ul>
      <li>
        <b>Statistics histogram</b>: for the chosen map category and type,
        presents the quantity of mesh points whose value falls within a certain
        range. Can be toggled from "View choice" in "Dashboard settings".
      </li>
      <li>
        <b>Global histogram</b>: for the chosen map category, presents the
        quantity of incidences where the the metric (map category) value fell
        within a certain range for the ensemble of mesh points. Can be toggled
        from "View choice" in "Dashboard settings".
      </li>
      <li>
        <b>Local histogram</b>: for the chosen map category, presents the
        quantity of incidences where the the metric (map category) value fell
        within a certain range for a single point in the map. Can be toggled
        from "View choice" in "Dashboard settings". The single point can be
        chosen from the revisit timeline coordinates input or by right-clicking
        the desired location on the 3D view. Not available in constellation
        comparison.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipHistograms'
}
</script>
